import { css } from '@/styled-system/css';

export const headerContainerStyles = css.raw({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  width: '100%',
  marginTop: { base: 'tight', xl: 'looser' },
  marginBottom: { xxl: 'loose' },
});

export const headingStyles = css.raw({
  xlDown: {
    textStyle: 'heading-sm',
    paddingLeft: 'default',
  },
  xl: {
    textStyle: 'heading-md',
    paddingLeft: 'default',
  },
  xxl: {
    paddingLeft: '0',
  },
});

export const filtersSelectorContainerStyles = css.raw({
  display: { base: 'none', xxl: 'block' },
});

export const foldersSelectorContainerStyles = css.raw({
  marginLeft: { base: 'auto', xxl: 'default' },
  marginRight: { base: 'default', xxl: '0' },
});
